/** The flight frame's chrome. */
export default {
  fetchingFlight: "Fetching flight details…",
  noFlight: "No flight selected",
  gate: "Gate",
  seat: "Seat",
  boarding: "Boarding",
  terminal: "Terminal",
  group: "Group",
  duration: "Duration",
  pnr: "PNR",
  barcodeAlt: "Boarding pass barcode",
  departs: "Departs",
  arrives: "Arrives",
} as const;
